import { AgxHeader } from '@urbanx/agx-ui-components'
import './reporting.scss'
import clsx from 'clsx'

interface RunRateButtonProps {
  onClick: () => void
  isActive: boolean
}

const RunRateButton = ({ onClick, isActive }: RunRateButtonProps) => {
  const styles = clsx('run-rate-header', {
    activeHeader: isActive,
    inactiveHeader: !isActive,
  })
  return (
    <div className={styles} onClick={onClick}>
      <AgxHeader size={5}>Run Rate</AgxHeader>
    </div>
  )
}

export default RunRateButton
